import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=01d48788&lang=pug&"
import script from "./PopupWindow.vue?vue&type=script&lang=js&"
export * from "./PopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d48788')) {
      api.createRecord('01d48788', component.options)
    } else {
      api.reload('01d48788', component.options)
    }
    module.hot.accept("./PopupWindow.vue?vue&type=template&id=01d48788&lang=pug&", function () {
      api.rerender('01d48788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PopupWindow.vue"
export default component.exports